// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const descriptionList = "DescriptionList__descriptionList__XimaK font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const dimmed = "DescriptionList__dimmed__4Wuh4";
export const fieldLabel = "DescriptionList__fieldLabel__Fr1ni";
export const fieldValue = "DescriptionList__fieldValue__ocVxe";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const labelText = "DescriptionList__labelText__yfCx4";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "DescriptionList__textCenter__wuZQl";
export const tooltipIconWrapper = "DescriptionList__tooltipIconWrapper__r2onl";